<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                A2P Registration Step 1 of 6
            </h2>
        </template>

        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8 shadow sm:rounded-md bg-white">
                <jet-form-section @submitted="saveProgress">
                    <template #title>
                        Step 1
                    </template>

                    <template #form>
                        <template v-if="form.is_business">

                            <div class="col-span-6">
                                <label class="flex flex-col">
                                    <div>
                                        Legal Company Name (i.e. include LLC if it is in your legal name)<span class="required">*</span>
                                    </div>
                                    <jet-input
                                        class="mt-1 block w-full"
                                        v-model="form.legal_business_name"
                                    />
                                </label>
                            </div>

                            <div class="col-span-6">
                                <label class="flex flex-col">
                                    <div>
                                        DBA (Doing business as) or brand name
                                    </div>
                                    <jet-input
                                        class="mt-1 block w-full"
                                        v-model="form.dba_name"
                                    />
                                </label>
                            </div>
                        </template>

                        <div class="col-span-6">
                            <label class="flex flex-col">
                                <div>Country <span class="required">*</span></div>
                                <multiselect
                                    v-model="countrySelected"
                                    :options="countryOptions"
                                    :searchable="false"
                                    label="label"
                                    select-label=""
                                    deselect-label=""
                                ></multiselect>
                            </label>
                        </div>
                        <template v-if="form.is_business && form.country">
                            <div class="col-span-6" >
                                <label class="flex flex-col">
                                    <div>
                                        {{registrationNumberName}}
                                        <span class="required">*</span>
                                    </div>
                                    <jet-input
                                        class="mt-1 block w-full"
                                        v-model="form.registration_number"
                                    />
                                </label>
                            </div>

                            <!-- hiding this for now, maybe revisit in the future -->
                            <div class="col-span-6" v-if="false">
                                <label class="flex items-center">
                                    <input
                                        type="checkbox"
                                        class="form-checkbox"
                                        v-model="form.no_ein"
                                        required
                                    />
                                    <span class="ml-2 text-sm text-gray-600">
                                        I don't have {{registrationNumberName == 'EIN' ? 'an' : 'a'}} {{registrationNumberName}}
                                    </span>
                                </label>

                                <div class="border-2 border-orange-400 bg-orange-100 p-4 rounded-lg mb-4 mt-4">
                                    Providing an {{registrationNumberName}} allows us to register your phone number for higher deliverability and sending limits. If you don't have an {{registrationNumberName}}, you'll still be able to send messages, but you may be subject to lower daily send limits and more frequent telecom carrier message filtering.
                                </div>
                            </div>
                            
                        </template>




                    </template>
                    <template #actions>
                        <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                            Saved.
                        </jet-action-message>

                        <jet-button
                            :class="{ 'opacity-25': form.processing }"
                            :disabled="!goodToContinue"
                        >
                            Next
                        </jet-button>
                    </template>
                </jet-form-section>
                
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import JetButton from "./../../Jetstream/Button";
import JetFormSection from "./../../Jetstream/FormSection";
import JetInput from "./../../Jetstream/Input";
import JetInputError from "./../../Jetstream/InputError";
import JetLabel from "./../../Jetstream/Label";
import JetActionMessage from "./../../Jetstream/ActionMessage";
import JetSecondaryButton from "./../../Jetstream/SecondaryButton";


export default {
    name: 'A2P-Step1',
    props: ["sessions"],
    components: {
        AppLayout,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        
        //vSelect
    },
    data() {
        return {
            countrySelected: null,
            form: this.$inertia.form(
                {
                    _method: "POST",
                    step: 1,
                    legal_business_name: '',
                    is_business: true,
                    country: '',
                    registration_number: '',
                    no_ein: '',
                    dba_name: '',
                },
                {
                }
            ),
            businessOrPersonalOptions: [
                {
                    label: 'Personal - Personal event / communication, friends, personal projects, etc',
                    value: 0
                },
                {
                    label: 'Business - Appointments, marketing, customer/client contact, etc',
                    value: 1
                }
                
            ],
            yesNoOptions: [
                {
                    label: 'Yes',
                    value: 1
                },
                {
                    label: 'No',
                    value: 0
                }
            ],
            countryOptions: [
                {
                    label: 'United States',
                    value: 'US'
                },
                {
                    label: 'Canada',
                    value: 'CA'
                }
            ]
            
        }
    },
    computed: {
        goodToContinue() {
            if (this.form.is_business === 0 &&
                this.form.country
            ) {
                return true;
            }

            //we know it is a business...

            if (! this.form.legal_business_name) return false;
            if (this.form.no_ein == 0 && !this.form.registration_number) return false;

            if (this.form.country == "US" && this.form.registration_number.length != 10) return false;
            if (this.form.country == "US" && this.form.registration_number[2] != "-") return false;

            if (this.form.country == "CA" && this.form.registration_number.length != 9) return false;


            if (this.hasEin && !this.form.country) return false;
            if (this.hasEin && !this.form.registration_number) return false;

            //should be good now
            return true;
        },
        registrationNumberName() {
            if(this.form.country == 'US') {
                return 'EIN  (XX-XXXXXXX)';
            }

            if(this.form.country == 'CA') {
                return 'Business Number (first 9 digits)' ;
            }
            
        },
        hasEin() {
            if (this.form.no_ein) {
                return false;
            }
            return true;
        }
    },
    mounted() {
        let a2p = this.$page.props.a2p;
        if (a2p ) {
            this.form.has_ein = !this.form.no_ein;
            this.form.dba_name = a2p.dba_name;
            this.form.legal_business_name = a2p.legal_business_name;
            this.form.country = a2p.country;
            this.form.registration_number = a2p.registration_number;
        }
    },
    methods: {
        saveProgress() {
            this.form.post("/verified/save-progress", {
                preserveScroll: true,
                onSuccess: (response) => {
                    
                },
            });
        },
    },
    watch: {
        countrySelected() {
            this.form.country = this.countrySelected.value;
        }
    }

};
</script>

<style lang="scss" scoped>

.required {
    @apply text-red-500 font-bold text-xl pl-1;
}

</style>
